h         = require 'virtual-dom/h'
RxWidget  = require 'ub/rx_widget'
Delegator = require 'dom-delegator'
_         = require 'lodash'
ubBanzai  = require 'ub/control/banzai-features'

delgator = new Delegator()

getButtonFromEvent = (ev) ->
  type = if ubBanzai.features.isSandboxEnabled() then 'saveDisabled' else ev.type
  buttonName = saveStateToButton[type]
  buttonDetails = buttons[buttonName] or buttons.enabled
  _.merge buttonName: buttonName, buttonDetails

saveStateToButton =
  pageSaving        : 'saving'

  saveDisabled      : 'disabled'
  pageSaveCompleted : 'disabled'

  pageSaveFailed    : 'enabled'
  saveEnabled       : 'enabled'
  pageUnsaved       : 'enabled'

buttonLabel = 'Save'

buttons =
  enabled:
    className  : 'save current'
    content    : buttonLabel
    useHandler : true

  disabled:
    className : 'save dsbl'
    content   : buttonLabel

  saving:
    className : 'saving'
    content   : 'Saving...'


# `saveDisabled` is used as the default here
previousSaveState =
  type: 'saveDisabled'

processStates = (sources) ->
  saveObs = sources
    .saveObs
    .filter (e) -> _.has(saveStateToButton, e.type)

  saveObs.subscribe (event) -> previousSaveState = event

  publishToSaveMapping = sources
    .publishObs
    .filter (ev) ->
      ev.type in [
        'readyToRepublish',
        'requestRepublish',
        'publishing',
        'publishSuccess',
        'publishError',
        'republishing',
        'republishSuccess',
        'republishError'
      ]
    .map (publishEv) ->
      pubEvs = [
        'readyToRepublish', 'requestRepublish',
        'publishing', 'republishing'
      ]
      if publishEv.type in pubEvs
        type: 'saveDisabled'
      else
        previousSaveState

    saveObs.merge publishToSaveMapping

class SaveButton
  render: (data) =>
    {buttonName,
     className,
     title,
     content,
     useHandler} = getButtonFromEvent data

    h 'div.save-button-container',
      h 'a.button.action.svg-ico-save',
        className : className
        title     : title

        # `undefined` removes the event handler
        'ev-click' : if useHandler then @saveHandler else undefined,

        h 'span.label',
          content


  widget: (sources, @saveHandler, @initialState = type: 'saveDisabled') ->
    eventObs = processStates sources
    new RxWidget eventObs, @render, @initialState

module.exports = SaveButton



// WEBPACK FOOTER //
// ./src/lp/editor/buttons/save-button.coffee